import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireRole }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-background text-muted-foreground">
                <div className="font-mono text-sm">loading vault…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }
    if (requireRole && user.role !== requireRole && user.role !== "admin") {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
